import React from "react";

import ClinicsList from "./ClinicsList";

import TableContainer from "../../../Shared/TableContainer";
import { LIMIT_OPTIONS } from "../../../PharmacyOrderList/constants";
import { useClinics } from "../hooks/useClinics";
import { useTablePagination } from "../../../../hooks/useTablePagination";

const ClinicsListContainer = () => {
  const {
    page,
    rowsPerPage,
    handlePageChange,
    handleRowsPerPageChange
  } = useTablePagination();

  const { clinics, isLoaded, total } = useClinics(page, rowsPerPage);

  return (
    <TableContainer>
      <ClinicsList
        isLoading={!isLoaded}
        clinics={clinics}
        onPageChange={handlePageChange}
        onRowsPerPageChange={handleRowsPerPageChange}
        page={page}
        rowsPerPage={rowsPerPage}
        total={total}
        rowsPerPageOptions={LIMIT_OPTIONS}
      />
    </TableContainer>
  );
};

export default ClinicsListContainer;
